import React from "react";
import { Grid, Box } from "@mui/material";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { Link } from "react-router-dom";
import { StyledSectionContainer } from "styles/components/SectionContainer/index.styles";
import { useTheme } from "@mui/material/styles";
import useMediaQueries from "utils/mediaQueries.utils";

const ThreeColumnSection = ({ title, description, items = [], cta, columnGap = 4, rowGap = 3, cssProps = {}, ...props }) => {
  const theme = useTheme();
  const { isMd } = useMediaQueries();

  return (
    <StyledSectionContainer sx={cssProps} {...props}>
      {/* Header Section */}
      {(title || description) && (
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
          {title && (
            <MKTypography
              variant="h2"
              component="h2"
              sx={{
                mb: 2,
                color: "#fff",
                fontWeight: 600,
              }}
            >
              {title}
            </MKTypography>
          )}
          {description && (
            <MKTypography
              variant="body1"
              component="p"
              sx={{
                color: "#fff",
                maxWidth: "800px",
                mx: "auto",
                lineHeight: 1.6,
                opacity: 0.9,
              }}
            >
              {description}
            </MKTypography>
          )}
        </Box>
      )}

      {/* Three Column Items */}
      {items.length > 0 && (
        <Grid container spacing={{ xs: rowGap, md: columnGap }} justifyContent="center" alignItems="stretch">
          {items.map((item, index) => (
            <Grid item xs={12} md={4} key={index} sx={{ display: "flex" }}>
              <Box
                sx={{
                  textAlign: "center",
                  p: { xs: 2, md: 3 },
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {/* Icon */}
                {item.icon && (
                  <Box
                    sx={{
                      mb: 2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: { xs: 60, md: 80 },
                      height: { xs: 60, md: 80 },
                    }}
                  >
                    <Box
                      component="img"
                      src={item.icon.src}
                      alt={item.icon.alt}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        filter: "brightness(0) invert(1)", // Makes SVGs white
                      }}
                    />
                  </Box>
                )}

                {/* Title */}
                {item.title && (
                  <MKTypography
                    variant="h6"
                    component="h3"
                    sx={{
                      mb: 1.5,
                      color: `${theme.palette.white.main} !important`,
                      fontWeight: 600,
                      // lineHeight: 1.3,
                      minHeight: "52px",
                    }}
                  >
                    {item.title}
                  </MKTypography>
                )}

                {/* Description/Content */}
                {(item.description || item.content) && (
                  <MKTypography
                    variant="body2"
                    component="p"
                    sx={{
                      color: theme.palette.white.main,
                      opacity: 0.7,
                      lineHeight: 1.5,
                      flex: 1,
                    }}
                  >
                    {item.description || item.content}
                  </MKTypography>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      )}

      {/* CTA Button */}
      {cta && (
        <Box sx={{ textAlign: "center", mt: { xs: 3, md: 4 } }}>
          <MKButton
            component={Link}
            to={cta.link}
            target={cta.external ? "_blank" : undefined}
            rel={cta.external ? "noopener noreferrer" : undefined}
            variant="contained"
            color="secondary"
            size="large"
            aria-label={cta.ariaLabel || cta.text}
            sx={{ minWidth: isMd ? "200px" : "auto" }}
          >
            {cta.text}
          </MKButton>
        </Box>
      )}
    </StyledSectionContainer>
  );
};

export default ThreeColumnSection;
